import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Briefcase } from 'lucide-react';
import './FormStyles.css';

const url = process.env.REACT_APP_BACKEND_URL;

const JobAvailabilityForm = ({ onSubmit, onBack, initialData }) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    jobname_id: initialData?.jobname_id || initialData?.jobname || '',
    jobname: '',
    section: initialData?.section || ''
  });

  const sectionOptions = ['Full Time', 'Part Time', 'Day', 'Night', 'Morning', 'Afternoon'];

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${url}/api/jobcategory/all`);
      setJobs(response.data.data || []);
    } catch (error) {
      console.error('Failed to fetch jobs:', error);
      toast.error('Failed to load job categories');
    } finally {
      setLoading(false);
    }
  };

  const getJobNameById = (jobId) => {
    if (!jobId) return '';
    const job = jobs.find(j => j._id === jobId);
    return job ? job.category_name : '';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'jobname_id') {
      const jobName = getJobNameById(value);
      setData(prev => ({ 
        ...prev, 
        jobname_id: value,
        jobname: jobName
      }));
    } else {
      setData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!data.jobname_id) {
      toast.error('Please select a job');
      return;
    }
    if (!data.section) {
      toast.error('Please select a section');
      return;
    }

    // PASS BOTH ID AND NAME TO PARENT - NO API CALL
    onSubmit({
      jobname_id: data.jobname_id,
      jobname: data.jobname,
      section: data.section
    });
  };

  if (loading) {
    return (
      <div className="form-card">
        <h2 className="form-title">
          <Briefcase size={24} /> Job Availability
        </h2>
        <div className="loading-spinner">Loading job categories...</div>
      </div>
    );
  }

  return (
    <div className="form-card">
      <h2 className="form-title">
        <Briefcase size={24} /> Job Availability
      </h2>

      <form className="dynamic-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Select Job *</label>
          <select name="jobname_id" value={data.jobname_id} onChange={handleChange} required>
            <option value="">Select a job category</option>
            {jobs.map(job => (
              <option key={job._id} value={job._id}>{job.category_name}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Section *</label>
          <select name="section" value={data.section} onChange={handleChange} required>
            <option value="">Select section</option>
            {sectionOptions.map(section => (
              <option key={section} value={section}>{section}</option>
            ))}
          </select>
        </div>

        <div className="form-actions">
          <button type="button" onClick={onBack} className="back-btn">Back</button>
          <button type="submit" className="submit-btn">Next →</button>
        </div>
      </form>
    </div>
  );
};

export default JobAvailabilityForm;